// extracted by mini-css-extract-plugin
module.exports = {"signup_box":"Register_signup_box__3SskP","signup_form":"Register_signup_form__183KP"};